import i18n from 'shared/lib/i18n';

import { getIsTimeError } from '../Schedule/utils';

// amenity schedule validation
export const amenityTimeConstraintsValidation = (value, values) => {
  const { minimumReservationTime: startTime, maximumReservationTime: endTime } =
    values;
  const isTimeError = getIsTimeError({
    startTime,
    endTime,
  });
  if (isTimeError) {
    return i18n.t('errors.invalidTimeRange');
  }
  return null;
};
